import type { SessionStatus } from '@UI/Store/AuthenticatedUser';
import type AuthenticatedUserView from '@UI/Store/AuthenticatedUser/Views/AuthenticatedUserView';
import * as React from 'react';

export type AuthenticatedUserContextValue = {
	readonly user: AuthenticatedUserView | null;
	readonly sessionStatus: SessionStatus;
};

const AuthenticatedUserContext = React.createContext<AuthenticatedUserContextValue | null>(null);

export default AuthenticatedUserContext;
